// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  envName: 'local',
  production: false,
  hostname: 'localhost:4200',
  //localhost Redirect URL
  // redirectUrl: `https://login.microsoftonline.com/tmnatest.onmicrosoft.com/oauth2/authorize?client_id=1b32b72d-2208-48b7-9c1b-5dd881c7aabd&response_type=id_token&redirect_uri=http%3A%2F%2Flocalhost:4200%2F%23%2Flogin%2F&scope=openid&state=12345&nonce=678910`,
 //QA Redirect URL
  redirectUrl: `https://login.microsoftonline.com/tmnatest.onmicrosoft.com/oauth2/authorize?client_id=1b32b72d-2208-48b7-9c1b-5dd881c7aabd&response_type=id_token&redirect_uri=https%3A%2F%2Fnew.tourtoyota.qa.toyota.com%2F%23%2Flogin%2F&scope=openid&state=12345&nonce=678910`,
  // adminBaseUrl: "https://72us2vtk8j.execute-api.us-east-1.amazonaws.com/qa/api/",
  // createReservationBaseUrl: 'https://b43oklydn8.execute-api.us-east-1.amazonaws.com/qa/api/',
  // reportBaseUrl: 'https://35rk9usutg.execute-api.us-east-1.amazonaws.com/qa/api/',
  // regisBaseUrl: 'https://1q0j4va120.execute-api.us-east-1.amazonaws.com/qa/api/',
  // cancelEmailBaseUrl: 'https://jl7dsq4484.execute-api.us-east-1.amazonaws.com/qa/api/',
  // managePlantBaseUrl: 'https://pyg2pooyk8.execute-api.us-east-1.amazonaws.com/qa/api/',

  adminUrl : "https://api.new.tourtoyota.qa.toyota.com/admin/",
  schedularUrl : "https://api.new.tourtoyota.qa.toyota.com/",
  // saveTokenBaseUrl: 'https://ovh4hv03v4.execute-api.us-east-1.amazonaws.com/qa/api/',
  //  tourSaveTokenUrl :'https://ovh4hv03v4.execute-api.us-east-1.amazonaws.com/qa/api/JWT',

  saveTokenBaseUrl: 'https://api.new.tourtoyota.qa.toyota.com/token/',
  tourSaveTokenUrl :'https://api.new.tourtoyota.qa.toyota.com/token/JWT/{proxy+}',
  exportDownloadUrl: 'https://d3j2rxbv4mtei3.cloudfront.net/',
  clientId: 'a7fd5d8f-fad0-45e1-a8a6-57961824b68a'
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.